import {
    cutRoute,
    fetchRouteContent, forceAssign, prioritizeRoute,
    sideLineRoute, unassignAssociate
} from "../../pickStatus/network/PickNetworkAPI";
import {ROUTE_INFO_METRIC_KEY} from "../../util/MetricUtil";

export const RouteDetailReducer = (state, action) => {
    switch(action.type) {
        case "LOAD_VIEW":
            const {routeId, dispatcher, baseUrl, capability, routeStatus, stationCode, stationConfig} = action.data;
            fetchRouteContent(routeId, dispatcher, baseUrl, capability, routeStatus, stationCode, stationConfig)
            return {...state, isLoading: true}
        case "UNLOAD_VIEW":
            return state
        case "RECEIVE_DATA":
            return {...state, ...action.data}
        case "CHANGE_PICKLIST":
            return {...state, selectedPicklist: action.data.selectedPicklist}
        case "CHANGE_PICKLIST_TAB":
            return {...state, selectedPicklistTab: action.data.selectedPicklistTab}
        case "CUT_ROUTE":
        {
            const {dispatcher, routeId, stationCode, baseUrl, alertDispatch, stationConfig} = action.data;
            cutRoute(dispatcher, routeId, stationCode, baseUrl, alertDispatch, stationConfig);
            return state;
        }
        case "PRIORITIZE_ROUTE":
        {
            prioritizeRoute(action.data);
            return state;
        }
        case "SIDELINE_ROUTE":
        {
            const {dispatcher, routeId, stationCode, baseUrl, alertDispatch, stationConfig} = action.data;
            sideLineRoute(dispatcher, routeId, stationCode, baseUrl, alertDispatch, stationConfig, ROUTE_INFO_METRIC_KEY);
            return {...state, isLoading: true};
        }
        case "FORCE_ASSIGN": {
            const {dispatcher, routeId, stationCode, baseUrl, alertDispatch, stationConfig} = action.data;
            forceAssign(dispatcher, routeId, stationCode, baseUrl, alertDispatch, stationConfig);
            return {...state, isLoading: true};
        }
        case "UNASSIGN_ASSOCIATE":
        {
            unassignAssociate(action.data);
            return {...state, isLoading: true};
        }
        case "HIDE_LOADER":
            return {...state, isLoading: false}
        case "SET_USER_AUTHORIZATION":

                return  {...state, isAuthorizedUser: action.data.isAuthorizedUser,
                    isTCPAuthorizationCheckEnabled: action.data.isTCPAuthorizationCheckEnabled }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/components/routeDrillDown/reducer/RouteDetailReducer.js